import { SvgIcon, SvgIconProps } from '@mui/material'

const SrpTipLayoverIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 32 32">
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6440_54300)">
                <path d="M8 13.3333H24" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 21.3333H24" stroke="#FEC524" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8 10.6667C8 9.95942 8.28095 9.28115 8.78105 8.78105C9.28115 8.28095 9.95942 8 10.6667 8H21.3333C22.0406 8 22.7189 8.28095 23.219 8.78105C23.719 9.28115 24 9.95942 24 10.6667V24C24 24.7072 23.719 25.3855 23.219 25.8856C22.7189 26.3857 22.0406 26.6667 21.3333 26.6667H10.6667C9.95942 26.6667 9.28115 26.3857 8.78105 25.8856C8.28095 25.3855 8 24.7072 8 24V10.6667Z" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 8V6.66667C12 5.95942 12.281 5.28115 12.781 4.78105C13.2811 4.28095 13.9594 4 14.6667 4H17.3333C18.0406 4 18.7189 4.28095 19.219 4.78105C19.719 5.28115 20 5.95942 20 6.66667V8" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12 26.6667V28" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M20 26.6667V28" stroke="#154588" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_6440_54300">
                    <rect width="32" height="32" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    </SvgIcon>
)

export default SrpTipLayoverIcon
